//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SignUp',
  components: {
    Hero: () => import('@/components/contributor/signup/Hero.vue'),
    LookingFor: () => import('@/components/contributor/signup/LookingFor.vue'),
    EarningsSteps: () => import('@/components/contributor/signup/EarningsSteps.vue'),
    Perks: () => import('@/components/contributor/signup/Perks.vue'),
    WaysToSell: () => import('@/components/contributor/signup/WaysToSell.vue'),
    Referrals: () => import('@/components/contributor/signup/Referrals.vue'),
    Sales: () => import('@/components/contributor/signup/Sales.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    HeroFooter: () => import('@/components/contributor/signup/HeroFooter.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  computed: {
    pageTitle() {
      return this.$t('contributor.intro.hero_heading');
    },
    pageDescription() {
      return this.$t('contributor.intro.hero_subheading');
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('term.contributors'),
          link: this.$link('/contributors').url(),
          active: true,
        },
      ];
    },
  },
};
